export type PreviewScrollAction = 'selection' | 'panel' | 'highlight';

/**
 * Selecting text, or opening Ny markering, must not move the preview.
 * At 171% an A4 page is taller than the pane. scrollIntoView({ block: 'center' })
 * on that page pulls scrollTop upward so the selection jumps toward the top.
 * A highlight chosen from the list only scrolls when its page is fully outside
 * the pane.
 */
export function previewScrollTopAfter(input: {
  action: PreviewScrollAction;
  scrollTop: number;
  zoom: number;
  containerTop?: number;
  containerHeight?: number;
  pageTop?: number;
  pageHeight?: number;
}): number {
  if (!Number.isFinite(input.scrollTop)) return 0;
  if (input.action === 'selection' || input.action === 'panel') return input.scrollTop;
  if (
    input.containerTop == null ||
    input.containerHeight == null ||
    input.pageTop == null ||
    input.pageHeight == null
  ) {
    return input.scrollTop;
  }
  const containerBottom = input.containerTop + input.containerHeight;
  const pageBottom = input.pageTop + input.pageHeight;
  const visible = pageBottom > input.containerTop && input.pageTop < containerBottom;
  if (visible) return input.scrollTop;
  return input.scrollTop + (input.pageTop - input.containerTop);
}

export function assignScrollTopToReveal(container: HTMLElement, target: HTMLElement): void {
  const containerBox = container.getBoundingClientRect();
  const targetBox = target.getBoundingClientRect();
  const next = previewScrollTopAfter({
    action: 'highlight',
    scrollTop: container.scrollTop,
    zoom: 1,
    containerTop: containerBox.top,
    containerHeight: container.clientHeight || containerBox.height,
    pageTop: targetBox.top,
    pageHeight: targetBox.height,
  });
  if (next !== container.scrollTop) container.scrollTop = next;
}
